import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Account, Privilege } from 'services';
import { ModelsActions } from "store/actions";
import { account_manager } from 'utils/constants';
import { CreateModal, Results } from './components';

const AccountList = props => {
  const dispatch = useDispatch();

  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader header="All Accounts" subheader="Account Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Account
        </Button>
      </GenericHeader>
    );
  }
  const reload = async () => {
    const roles = await Privilege.list({});
    dispatch(ModelsActions.update_model({ roles: roles.models }));
  }

  useEffect(() => {
    reload();
    // eslint-disable-next-line
  }, []);

  return (
    <ListComp
      listing={Account.list}
      title="Accounts"
      name="accounts"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[account_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default AccountList;
